module.exports = __webpack_public_path__ + "img/valores.efed1752.png";